'use strict';
import noUiSlider from 'nouislider';
import Decimal from 'decimal.js';

class InstallmentCalculator {
    constructor(options = {}) {
        // Устанавливаем значения по умолчанию
        let {
            downPaymentScaleMin = 0,
            downPaymentScaleMax = 100,
            downPaymentStep = 10,
            fractionDigits = 2,
            currency = 'BYN',
            precision = 28,
            elementId = '',
        } = options;

        // Приводим значения к нужному типу данных
        downPaymentScaleMin = Number(downPaymentScaleMin);
        downPaymentScaleMax = Number(downPaymentScaleMax);
        downPaymentStep = Number(downPaymentStep);
        this.fractionDigits = Number(fractionDigits);
        this.currency = ' ' + String(currency);
        precision = Number(precision);
        elementId = String(elementId);

        if (!elementId) {
            throw new Error('elementId не может быть пустым.');
        }

        if (precision <= 0) {
            throw new Error('Точность вычислений не может быть ниже нуля.');
        }
        Decimal.set({precision: precision});

        // Проверяем значения на соответствие требованиям
        if (downPaymentScaleMin < 0) {
            throw new Error('Минимальный первый взнос не может быть < 0 %.');
        } else if (downPaymentScaleMin >= 100) {
            throw new Error('Минимальный первый взнос не может быть >= 100 %.');
        }

        if (downPaymentScaleMax <= 0) {
            throw new Error('Максимальный первый взнос не может быть <= 0 %.');
        } else if (downPaymentScaleMax > 100) {
            throw new Error('Максимальный первый взнос не может быть > 100 %.');
        }

        if (downPaymentScaleMin === downPaymentScaleMax) {
            throw new Error('Минимальный и максимальный первый взнос не могут быть равными.');
        } else if (downPaymentScaleMin > downPaymentScaleMax) {
            throw new Error('Минимальный первый взнос не может быть > максимального первого взноса.');
        }

        if (downPaymentStep <= 0) {
            throw new Error('Шаг первого взноса не может быть <= 0.');
        } else if (downPaymentStep > (downPaymentScaleMax - downPaymentScaleMin)) {
            throw new Error('Шаг первого взноса не может быть > чем разница между максимальным и минимальным первым взносом.');
        }

        // Инициируем popup
        let installmentPopup = $('#installment-popup-' + elementId)
        if (installmentPopup) {
            installmentPopup.popup({
                scrolllock: true
            });
        } else {
            throw new Error('Не найден popup.');
        }

        // Устанавливаем денежный формат
        this.numberFormat = new Intl.NumberFormat('ru-RU', {
            minimumFractionDigits: this.fractionDigits, maximumFractionDigits: this.fractionDigits
        })

        // Находим элементы для вывода результатов
        let calculator = document.getElementById('installment-calculator-' + elementId);
        calculator.dataset.init = 'true'
        let lines = calculator.querySelectorAll('.calculator__value');
        this.downPaymentElement = lines[0];
        this.downPaymentElementPercentage = lines[1];
        this.paymentPeriod = lines[2];
        this.monthlyPaymentElement = lines[3];
        this.totalPaymentElement = lines[4];
        this.overpaymentElement = lines[5];
        if (!this.downPaymentElement || !this.downPaymentElementPercentage || !this.paymentPeriod || !this.totalPaymentElement || !this.monthlyPaymentElement || !this.overpaymentElement) {
            throw new Error('Не найдены элементы для вывода результатов.');
        }

        // Получаем данные о доступных банковских продуктах
        this.productData = JSON.parse(calculator.dataset.json || '');
        if (!this.productData || typeof this.productData.price !== 'number' || !Array.isArray(this.productData.products)) {
            throw new Error('Некорректные данные о продукте.');
        }

        // Создаём слайдер первого взноса
        let sliders = calculator.querySelectorAll('.calculator__slider-nouislider')
        this.downPaymentSlider = sliders[0]
        if (!this.downPaymentSlider) {
            throw new Error('Не найден слайдер первого взноса.');
        }


        // Минимально доступный первый взнос
        let downPaymentValueMin = this.productData.downPaymentValueMin

        let periods = []
        for (let i = downPaymentScaleMin; i <= downPaymentScaleMax; i += downPaymentStep) {
            periods.push(i);
        }
        noUiSlider.create(this.downPaymentSlider, {
            start: downPaymentValueMin > downPaymentScaleMin ? downPaymentValueMin : downPaymentScaleMin,
            range: this.noUiSliderRageGenerate(periods),
            snap: true,
            connect: 'lower',
            pips: {
                mode: 'values', values: periods, density: -1,
            },
        });

        if (downPaymentValueMin > downPaymentScaleMin) {
            this.downPaymentSlider.noUiSlider.on('update', (values, handle) => {
                let value = values[handle];
                if (value < downPaymentValueMin) {
                    this.downPaymentSlider.noUiSlider.set(downPaymentValueMin);
                }
            });
        }

        // Находим слайдер периода
        this.paymentPeriodSlider = sliders[1]
        if (!this.paymentPeriodSlider) {
            throw new Error('Не найден слайдер периода.');
        }

        // Обрабатываем событие изменения слайдера первого взноса
        this.downPaymentSlider.noUiSlider.on('update', this.calculatePayment.bind(this));
    }

    selectOptimalProducts(remainingPrice) {
        // Получаем банковские продукты которые подходят по сумме
        // (больше минимальной и меньше максимальной для банковского продукта)
        let productsByPeriod = {};
        let overpaymentByPeriod = {};
        this.productData.products.forEach(product => {
            product.minAmount = product.minAmount || 0.0;
            product.maxAmount = product.maxAmount || 0.0;
            product.graceRate = product.graceRate || 0.0;
            product.rate = product.rate || 0.0;
            product.gracePeriod = product.gracePeriod || 0;
            product.period = product.period || 0;

            if (remainingPrice >= product.minAmount && remainingPrice <= product.maxAmount) {
                if (!productsByPeriod[product.period]) {
                    productsByPeriod[product.period] = [];
                }
                // Для каждого продукта делаем расчёт платежей
                product = this.productCalculatePayment(remainingPrice, product)

                // Если такого периода ещё нет, то добавляем продукт,
                // Или если переплата по такому периоду выше чем у нового продукта, то заменяем продукт.
                // Таким образом останутся только банковские продукты с минимальной переплатой.
                if (!(product.period in overpaymentByPeriod)) {
                    overpaymentByPeriod[product.period] = product.overpayment;
                    productsByPeriod[product.period].push(product);
                } else if (overpaymentByPeriod[product.period] > product.overpayment) {
                    overpaymentByPeriod[product.period] = product.overpayment;
                    productsByPeriod[product.period] = [];
                    productsByPeriod[product.period].push(product);
                }
            }
        });

        return productsByPeriod;
    }

    calculatePayment() {
        // Выводим процент первого взноса
        let downPaymentPercent = this.downPaymentSlider.noUiSlider.get();
        this.downPaymentElementPercentage.textContent = downPaymentPercent + ' %';

        // Выводим сумму первого взноса
        let downPaymentPercentDecimal = new Decimal(String(downPaymentPercent))
        let price = new Decimal(this.productData.price)
        let downPayment = price.dividedBy(100).times(downPaymentPercentDecimal).toFixed(2, Decimal.ROUND_HALF_UP)

        this.downPaymentElement.textContent = this.numberFormat.format(downPayment) + this.currency;
        this.downPaymentElement.dataset.value = this.roundToTwoDecimals(downPayment);

        // Получаем оставшуюся стоимость товара без учёта первого взноса
        let remainingPrice = this.productData.price - downPayment

        // Получаем для каждого периода самые выгодные предложения
        let productsByPeriod = this.selectOptimalProducts(remainingPrice);
        // Получаем периоды и сортируем их по возрастанию
        let newPeriods = Object.keys(productsByPeriod).map(Number).sort((a, b) => a - b);
        let needCreateSlider = false;

        // Создаём слайдер периода
        if (this.paymentPeriodSlider.noUiSlider && this.compareArrays(this.periods, newPeriods)) {
            // Если слайдер создан и старые периоды не равны новым
            needCreateSlider = true;
        } else if (!this.paymentPeriodSlider.noUiSlider) {
            // Если слайдер не создан
            needCreateSlider = true;
        }
        if (needCreateSlider) {
            // Если уже задан какой-то период, то выбираем значение максимально близкое к нему,
            // если подходит два, то берём большее.
            let currentPeriod
            if (this.paymentPeriodSlider.noUiSlider) {
                currentPeriod = this.findClosestValue(newPeriods, this.paymentPeriodSlider.noUiSlider.get());
                // Уничтожаем слайдер
                this.paymentPeriodSlider.noUiSlider.destroy();
            } else {
                currentPeriod = Math.min(...newPeriods);
            }
            noUiSlider.create(this.paymentPeriodSlider, {
                start: currentPeriod,
                range: this.noUiSliderRageGenerate(newPeriods),
                snap: true,
                connect: 'lower',
                pips: {
                    mode: 'values', values: newPeriods, density: -1,
                }
            });

            // Обрабатываем событие изменения слайдера периода
            this.paymentPeriodSlider.noUiSlider.on('update', this.displayCalculations.bind(this, productsByPeriod));

            // Запоминаем все периоды
            this.periods = newPeriods;
        } else {
            this.displayCalculations(productsByPeriod);
        }
    }

    displayCalculations(productsByPeriod) {
        let period = parseInt(this.paymentPeriodSlider.noUiSlider.get(), 10);
        let product = productsByPeriod[period][0];

        this.paymentPeriod.textContent = period + ' мес.';
        this.totalPaymentElement.textContent = this.numberFormat.format(product.totalPayment) + this.currency;
        this.monthlyPaymentElement.textContent = this.numberFormat.format(product.monthlyPayment) + this.currency;
        this.overpaymentElement.textContent = this.numberFormat.format(product.overpayment) + this.currency;
    }

    findClosestValue(arr, target) {
        let minDiff = Infinity;
        let closestValue = null;

        for (const value of arr) {
            const diff = Math.abs(value - target);
            if (diff < minDiff) {
                minDiff = diff;
                closestValue = value;
            } else if (diff === minDiff && value > closestValue) {
                closestValue = value; // Выбираем большее значение при равных разницах
            }
        }

        return closestValue;
    }

    compareArrays(arr1, arr2) {
        if (arr1.length !== arr2.length) {
            return true; // Массивы разной длины, поэтому они разные
        }

        for (let i = 0; i < arr1.length; i++) {
            if (arr1[i] !== arr2[i]) {
                return true; // Найден отличающийся элемент
            }
        }

        return false; // Все элементы совпадают, массивы одинаковые
    }

    roundToTwoDecimals(num) {
        return Math.round(num * 100) / 100;
    }

    /**
     * Расчёт платежей
     * Банки в начале стремятся рассчитать общую сумму платежей. После считают ежемесячный платёж.
     * Иначе округлённый ежемесячный платёж даёт большую погрешность при вычислении общей сумм
     * @param remainingPrice
     * @param product
     * @returns {*}
     */
    productCalculatePayment(remainingPrice, product) {
        // Типы продуктов (*type*):
        // 1 - лизинг
        // 2 - рассрочка
        // 3 - комбо-кредит
        // 4 - базовый кредит
        // 5 - продукт с грейс-периодом (2 срока: минимальный (например 5 мес. с 0,001%) и максимальный (например 24 мес с б$о'$льшими процентами))

        let totalPayment = new Decimal(0.0);
        let monthlyPaymentDecimal;
        let decimal_remainingPrice = new Decimal(remainingPrice);
        let decimal_product_rate = new Decimal(product.rate);
        let decimal_product_grace_rate = new Decimal(product.graceRate);
        let decimal_product_period = new Decimal(product.period);
        let decimal_product_grace_period = new Decimal(product.gracePeriod);

        if (product.type === 1) {
            // Лизинг
            monthlyPaymentDecimal = decimal_remainingPrice.dividedBy(decimal_product_period).plus(decimal_remainingPrice.dividedBy(100).times(decimal_product_rate));
        } else if (product.type === 2) {
            // Рассрочка
            monthlyPaymentDecimal = decimal_remainingPrice.dividedBy(decimal_product_period)
            // Не высчитываем totalPayment как monthlyPayment * product.period, так как из-за округления получится меньше
            // и придётся увеличивать сумму последнего платежа. Поэтому просто приравниваем
            totalPayment = decimal_remainingPrice;
        } else if (product.type === 3 || product.type === 4) {
            // Кредит
            monthlyPaymentDecimal = this.annuity(decimal_product_rate, decimal_product_period, decimal_remainingPrice).neg();
        } else if (product.type === 5) {
            // Продукт с грейс-периодом
            if (decimal_product_grace_period.greaterThanOrEqualTo(decimal_product_period)) {
                // Поскольку грей-период превышает обычный период, то мы считаем по product.period
                monthlyPaymentDecimal = this.annuity(decimal_product_grace_rate, decimal_product_period, decimal_remainingPrice).neg();
                // Не можем выставить totalPayment = remainingPrice так как грей-период обычно близок к 0%, но больше нуля.
            } else {
                // Вычисляем сумму которую нужно выплатить во время грейс-периода
                let remainingPriceForGracePeriod = decimal_remainingPrice.dividedBy(decimal_product_period).times(decimal_product_grace_period);
                // Вычисляем ежемесячные выплаты во время грейс-периода
                let graceMonthlyPaymentDecimal = this.annuity(decimal_product_grace_rate, decimal_product_grace_period, remainingPriceForGracePeriod).neg();
                // Сумма выплат во время грейс-периода
                let totalGracePayment = graceMonthlyPaymentDecimal.times(decimal_product_grace_period);

                let afterGracePeriodRemainingPrice = decimal_remainingPrice.minus(totalGracePayment);
                let afterGracePeriod = decimal_product_period.minus(decimal_product_grace_period);
                let afterGraceMonthlyPaymentDecimal = this.annuity(decimal_product_rate, afterGracePeriod, afterGracePeriodRemainingPrice).neg();
                let totalAfterGracePayment = afterGraceMonthlyPaymentDecimal.times(afterGracePeriod);

                totalPayment = totalGracePayment.plus(totalAfterGracePayment);
                monthlyPaymentDecimal = totalPayment.dividedBy(decimal_product_period);
            }
        }

        if (totalPayment.equals(0.0)) {
            totalPayment = monthlyPaymentDecimal.times(decimal_product_period);
        }
        let overpayment = totalPayment.minus(decimal_remainingPrice);

        product.monthlyPayment = parseFloat(monthlyPaymentDecimal.toFixed(2, Decimal.ROUND_HALF_UP)) // Number -  обычная цифра
        product.totalPayment = parseFloat(totalPayment.toFixed(2, Decimal.ROUND_HALF_UP)); // Number -  обычная цифра
        product.overpayment = parseFloat(overpayment.toFixed(2, Decimal.ROUND_HALF_UP)); // Number -  обычная цифра

        return product;
    }

    annuity(i, n, s) {
        if (i.equals(0)) {
            return s.dividedBy(n);
        }
        i = i.dividedBy(100).dividedBy(12)
        const one = new Decimal(1);
        // Calculate components using Decimal methods
        const numerator = i.times(one.plus(i).pow(n));
        const denominator = one.plus(i).pow(n).minus(one);
        // Perform division and return Decimal result
        return s.times(numerator.dividedBy(denominator)).neg();
    }

    noUiSliderRageGenerate(periods) {
        // Делаем все периоды с равным интервалом на слайдере
        let range = {};
        let minPeriod = Math.min(...periods);
        let maxPeriod = Math.max(...periods);
        range['min'] = [minPeriod]; // Минимум
        let stepPercent = 100 / (periods.length - 1);
        let percent = stepPercent;
        periods.forEach(period => {
            if (period !== minPeriod && period !== maxPeriod) {
                range[percent + '%'] = [period];
                percent += stepPercent
            }
        });
        range['max'] = [maxPeriod]; // Максимум

        return range;
    }
}

function initialize() {
    let elements = document.querySelectorAll('[id^="installment-calculator-"]:not([data-init="true"])');
    elements.forEach(element => {
        let match = element.id.match(/^installment-calculator-(\d+)$/);
        if (match) {
            let elementId = parseInt(match[1], 10);
            new InstallmentCalculator({
                downPaymentScaleMin: 0,
                downPaymentScaleMax: 50,
                downPaymentStep: 10,
                fractionDigits: 2,
                precision: 28,
                elementId: elementId,
            });
        }
    });
}

// Инициализация новых калькуляторов при первой загрузке страницы.
document.addEventListener('DOMContentLoaded', () => {
    initialize()
});
// Инициализация новых калькуляторов при навигации кнопками браузера (в ajax режиме) когда получен ajax.
if (typeof BX !== 'undefined') {
    BX.addCustomEvent('onComponentAjaxHistoryGetState', () => {
        initialize()
    });
}
